import React from 'react';
import PropTypes from 'prop-types';

/**
 * EmptyState component for showing when no data is available
 * Displays icon, title, description, and optional action button
 */
const EmptyState = ({
  icon: Icon,
  title,
  description,
  action,
  actionLabel = 'Add Item',
  className = '',
}) => {
  return (
    <div className={`tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-12 tw-px-4 ${className}`}>
      {Icon && (
        <div className="tw-text-slate-300 tw-mb-4">
          <Icon size={48} />
        </div>
      )}

      {title && (
        <h3 className="tw-font-semibold tw-text-lg tw-text-slate-900 tw-mb-2">
          {title}
        </h3>
      )}

      {description && (
        <p className="tw-text-sm tw-text-slate-500 tw-mb-6 tw-text-center tw-max-w-sm">
          {description}
        </p>
      )}

      {action && (
        <button
          onClick={action}
          className="tw-px-4 tw-py-2 tw-text-sm tw-bg-blue-600 tw-text-white tw-rounded-md hover:tw-bg-blue-700 tw-transition-colors tw-cursor-pointer tw-border-0"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
};

EmptyState.propTypes = {
  icon: PropTypes.elementType,
  title: PropTypes.string,
  description: PropTypes.string,
  action: PropTypes.func,
  actionLabel: PropTypes.string,
  className: PropTypes.string,
};

export default EmptyState;
